module.exports = __webpack_public_path__ + "assets/img/vue_starter_npm_script.e3147849.jpg";